import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-norap items-center justify-between" }
const _hoisted_2 = { class: "text-muted text-xs font-[500]" }
const _hoisted_3 = {
  key: 0,
  class: "text-black font-semibold"
}


import Skeleton from '@/components/ui/skeleton/Skeleton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatQuery',
  props: {
  stat: {
    type: String,
    required: true
  },
  value: {
    type: Number,
    required: true
  },
  didQuery: {
    type: Boolean,
    required: false,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.stat), 1),
    (__props.didQuery)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.value), 1))
      : (_openBlock(), _createBlock(Skeleton, {
          key: 1,
          class: "w-12 h-4"
        }))
  ]))
}
}

})